import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import HomePage from "./pages/HomePage";
import TermsPage from "./pages/TermsPage";
import AuthPage from "./pages/AuthPage";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import PurchasePlan from "./pages/PurchasePlan";
import UserSetupPage from "./pages/UserSetupPage";
import BookingHistory from "./pages/BookingHistory";
import CarTypeSelection from "./components/CarTypeSelection";
import BookingCalendar from "./components/BookingCalendar";
import BookingConfirmation from "./pages/BookingConfirmation";
import IntegratedPurchaseFlow from "./components/IntegratedPurchaseFlow";
import PayPerUseSlotBooking from "./components/PayPerUseSlotBooking";
import RoleBasedRoute from "./components/RoleBasedRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import UserRedirect from "./components/UserRedirect";
import "./styles/input-fixes.css";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/login" element={<AuthPage />} />{" "}
          {/* User redirect route for role-based dashboard routing */}
          <Route
            path="/user"
            element={
              <ProtectedRoute>
                <UserRedirect />
              </ProtectedRoute>
            }
          />
          {/* User Setup Flow */}
          <Route
            path="/user-setup"
            element={
              <ProtectedRoute>
                <UserSetupPage />
              </ProtectedRoute>
            }
          />
          {/* Protected User Dashboard */}
          <Route
            path="/user-dashboard"
            element={
              <RoleBasedRoute requiredRole="user" redirectTo="/admin-dashboard">
                <UserDashboard />
              </RoleBasedRoute>
            }
          />
          {/* Protected Admin Dashboard */}
          <Route
            path="/admin-dashboard"
            element={
              <RoleBasedRoute requiredRole="admin" redirectTo="/user-dashboard">
                <AdminDashboard />
              </RoleBasedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <UserRedirect />
              </ProtectedRoute>
            }
          />{" "}
          {/* Purchase Flow Routes */}
          <Route
            path="/select-car-type"
            element={
              <ProtectedRoute>
                <CarTypeSelection />
              </ProtectedRoute>
            }
          />{" "}
          <Route
            path="/integrated-purchase-flow"
            element={
              <ProtectedRoute>
                <IntegratedPurchaseFlow />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pay-per-use-slot-booking"
            element={
              <ProtectedRoute>
                <PayPerUseSlotBooking />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase-plan"
            element={
              <ProtectedRoute>
                <PurchasePlan />
              </ProtectedRoute>
            }
          />{" "}
          {/* Booking Routes */}
          <Route
            path="/booking-calendar"
            element={
              <ProtectedRoute>
                <BookingCalendar />
              </ProtectedRoute>
            }
          />
          <Route
            path="/booking-history"
            element={
              <ProtectedRoute>
                <BookingHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/booking-confirmation"
            element={
              <ProtectedRoute>
                <BookingConfirmation />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
